import React, { useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';
import ProductCarousel from './ProductCarousel';
import { useProviderDetailsContext } from '../../contexts/providerDetails';
import { findProviderDetails } from '../../api/ecDataQueryApi';

const ProviderProductCarouselContainer = styled.div`
  position: relative;
  width: 100%;
`;

const LinkToProvider = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  background-color: white;
  height: 40px;
  line-height: 40px;
  padding: 0px 20px;
  text-decoration: underline;
  cursor: pointer;
  color: black;
  &:after{
    content: '';
    position: absolute;
    border-right: 2px solid black;
    border-top: 2px solid black;
    width: 7px;
    height: 7px;
    transform: rotate(45deg);
    margin-top: 17px;
  }
  &:hover{
    color: grey;
    &:after{
      border-color: grey;
    }
  }
`;

export default ({
  provider,
}) => {
  const { t } = useTranslation();

  const {
    providerDetails: providerDetailsCache,
    addProviderDetails,
  } = useProviderDetailsContext();

  useEffect(() => {
    if (!provider || providerDetailsCache[provider]) return;
    (async () => {
      try {
        const providerDetailsData = await findProviderDetails([provider]);
        providerDetailsData.forEach(({ key, value }) => {
          try {
            addProviderDetails(key, JSON.parse(value));
          } catch (error) {
            console.error(error);
          }
        });
      } catch (error2) {
        console.error(error2);
      }
    })();
  }, [provider]); //eslint-disable-line

  return (
    <ProviderProductCarouselContainer>
      <ProductCarousel
        name={_.get(providerDetailsCache, [provider, 'name'], '')}
        products={_.get(providerDetailsCache, [provider, 'highlightedProducts'], []).filter((d) => d)}
        showMoveButtons={false}
        align="left"
        titleStyle={{ fontSize: '26px', fontWeight: 'bold', transform: 'translateY(-10px)' }}
      />
      <Link to={`/ec/search/${provider}`}>
        <LinkToProvider>
          {t('ec.go_to_provider_page')}
        </LinkToProvider>
      </Link>
    </ProviderProductCarouselContainer>
  );
};
